import React, { useEffect } from "react";
import { Card, Input, Table, Row, Col } from "antd";
import { MinusCircleFilled, CheckCircleFilled } from "@ant-design/icons";
import { FormattedMessage, useIntl } from "react-intl";

function ProductsInfo() {
  const { Search } = Input;
  const { Column } = Table;

  const data = [
    {
      key: "1",
      sno: "1",
      productName: "Copper cable",
      quantity: "1",
      rate: "15",
      amount: "15",
      Warranty: 3,
      purchasedate: "21-Mar-2025",
      lastservicedate: "21-Jul-2025",
      nextservicedate: "21-Mar-2026",
    },
    {
      key: "2",
      sno: "2",
      productName: "High-Strength Concrete Mix",
      quantity: "2",
      rate: "150",
      Warranty: 3,
      amount: "300",
      purchasedate: "21-Mar-2025",
      lastservicedate: "21-Jul-2025",
      nextservicedate: "21-Mar-2026",
    },
    {
      key: "3",
      sno: "3",
      productName: "Reinforced Steel Bars",
      quantity: "2",
      rate: "2000",
      Warranty: 3,
      amount: "4000",
      purchasedate: "21-Mar-2025",
      lastservicedate: "21-Jul-2025",
      nextservicedate: "21-Mar-2026",
    },
  ];
  return (
    <>
      <Row align="middle">
        <Col xs={24} sm={8} md={8} lg={8} xl={8}>
          <Search placeholder="Search by products" allowClear />
        </Col>
      </Row>
      <Table
        className="mt-10"
        dataSource={data}
        pagination={false}
        scroll={{ x: 1100 }}
        bordered
        rowKey={(record, index) => index}
      >
        <Column
          title={<FormattedMessage id="WorkOrderDetails.Sno" />}
          dataIndex="sno"
          key="sno"
          render={(_, __, index) => index + 1}
        />
        <Column title="Product" dataIndex="productName" key="productName" />
        <Column title="Quantity" dataIndex="quantity" key="quantity" />
        <Column
          title="Date of Purchase"
          dataIndex="purchasedate"
          key="purchasedate"
        />

        <Column
          title="Warranty"
          dataIndex="Warranty"
          className="text-center"
          key="Warranty"
          render={(_, record) => (
            <span>
              <b>{record.Warranty} Years</b>
              <div className="warranty-circle mt-5px">
                <ul>
                  <li>
                    <CheckCircleFilled
                      style={{ color: "#389e0d", fontSize: 16 }}
                    />
                  </li>
                  <li>
                    <CheckCircleFilled
                      style={{ color: "#389e0d", fontSize: 16 }}
                    />
                  </li>
                  <li>
                    <MinusCircleFilled
                      style={{ color: "#999", fontSize: 16 }}
                    />
                  </li>
                </ul>
              </div>
            </span>
          )}
        />
        <Column
          title="Last service date"
          dataIndex="lastservicedate"
          key="lastservicedate"
        />
        <Column
          title="Next Service Date"
          dataIndex="nextservicedate"
          key="nextservicedate"
        />
      </Table>
    </>
  );
}

export default ProductsInfo;
